import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useLogout } from "../../utils/useLogout";

const useTokenExpirationCheck = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [timeDifference, setTimeDifference] = useState(null);
  const login = useSelector((state) => state.login);
  const { logout } = useLogout();

  useEffect(() => {
    const checkTokenExpiration = () => {
      const exp = login?.decodedTokenObject?.exp;
      const currentTimestamp = Date.now();

      if (!exp || exp <= Date.now()) {
        logout();
        return;
      }

      const timeDifference = exp - Date.now();
      const timeDifferenceInMinutes = timeDifference / 60000;
      setTimeDifference(timeDifferenceInMinutes);
      // console.log("Token - Current Timestamp", currentTimestamp);
      // console.log("Token Expiration timestamp", exp);
      // console.log(
      //   "Token Expiration =>>>>",
      //   "is token Expired :",
      //   exp <= Date.now()
      // );
      // console.log("Token timeDifferenceInMinutes", timeDifferenceInMinutes);

      if (timeDifferenceInMinutes <= 5 && timeDifferenceInMinutes > 0) {
        setShowPopup(true);
      }
    };

    checkTokenExpiration();
  }, [location.pathname]);

  return { showPopup, setShowPopup, timeDifference };
};

export default useTokenExpirationCheck;
